import { createFileRoute } from "@tanstack/react-router";
import PrivateSellLanding from "@/pages/PrivateSellLanding";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/vinde-masina/")({
  head: () => routeHead("/de/vinde-masina/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateSellLanding />
  );
}
